import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { Router } from "@angular/router";
import { ChatService } from '../../service/chat-service';
import { InteractionService } from '../../service/interaction/interaction.service';
import { RoleplayApiService } from '../../service/roleplay.service';
import { DateFormateService } from '../../date-formate.service';
import { ToastrService } from 'ngx-toastr';
import { AddQuestiontComponent } from '../add-questiont/add-questiont.component';
import { Subscription } from 'rxjs';
import { PlatformRegionService } from '../../service/shared/platform-region.service';
import { ChatRegionMarketService } from '../../v2/modules/roleplay/services/chat-region-market.service';
@Component({
    selector: 'app-question-list',
    templateUrl: './question-list.component.html',
    styleUrl: './question-list.component.scss',
    standalone: false
})
export class QuestionListComponent implements AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) private paginator: MatPaginator;
  showNoSearchResultsMessage: boolean = false;
  displayedColumns: string[] = ['faq', 'region_name', 'created_by', 'created_on', 'updated_by', 'updated_on', 'status', 'business_unit'];
  dataSource = new MatTableDataSource<any>([])
  filterValue: string;
  business_unit_code: string = sessionStorage.getItem('businessUnitCode');
  dataCount: number = 0;
  selectedSourceName = null;
  private refreshSubscription: Subscription;
  constructor(public Router: Router, private _liveAnnouncer: LiveAnnouncer, public roleplayservice: RoleplayApiService, private dateFormatService: DateFormateService,
    public dialog: MatDialog, private fb: FormBuilder, public ChatService: ChatService, public toastr: ToastrService,
    private readonly intService: InteractionService, private PlatformRegionService: PlatformRegionService, private ChatRegionService: ChatRegionMarketService) { }
  ngOnInit() {
    this.getBusinnessQuestions();
    this.refreshSubscription = this.intService.refresh$.subscribe(() => {
      this.getBusinnessQuestions();
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }
  addQuestion() {
    const dialogRef = this.dialog.open(AddQuestiontComponent, {
      width: '700px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  getBusinnessQuestions() {
    const region_name = this.ChatRegionService.selected_region_code || '';
    this.ChatService.getBusinnessFaq(this.business_unit_code, region_name).subscribe(res => {
      this.dataSource.data = [...res].sort((firstQuestion, secondQuestion) => secondQuestion.id - firstQuestion.id);
      if (this.paginator) {
        this.paginator.firstPage();
      }
    })
  }
  onStatusChange(event: any, element: any) {
    let isActivating: boolean = false;
    if (event.checked) {
      const activeQuestionsCount = this.dataSource?.data?.filter(q => q.status === 'Y').length;

      if (activeQuestionsCount >= 4) {
        event.source.checked = false;
        this.toastr.error('Only 4 questions can be activated at a time. This action cannot be completed.');
        return;
      }
      isActivating = true;
    }

    const request = {
      faq_id: element.id,
      new_status: isActivating ? 'Y' : 'N',
      modified_by: Number(sessionStorage.getItem('userId'))
    };

    this.ChatService.updateQuestionStatus(request).subscribe(
      response => {

        if (isActivating) {
          this.toastr.success('Question activated successfully.');
        } else {
          this.toastr.success('Question deactivated successfully.');
        }

        this.getBusinnessQuestions();
      },
      error => {
        this.toastr.error('Failed to update question status.');
        this.getBusinnessQuestions();
      }
    );
  }


  editQuestion(event: any, element: any) {
    const dialogRef = this.dialog.open(AddQuestiontComponent, {
      width: '700px',
      data: { faq: element.faq, id: element.id }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getBusinnessQuestions();
      }
    });

  }
}
